import { Link } from "react-router-dom";
import { LOGO_URL, CONTACT_EMAIL, MAILTO } from "../lib/brand";

const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-black/5 bg-white"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-10 py-12 md:py-16">
                <div className="grid md:grid-cols-3 gap-10 md:gap-6 items-start">
                    <div>
                        <Link
                            to="/"
                            data-testid="footer-logo-link"
                            className="inline-flex items-center gap-3"
                        >
                            <img
                                src={LOGO_URL}
                                alt="FreeByte"
                                className="h-12 w-auto object-contain"
                                data-testid="footer-logo-image"
                            />
                            <span className="text-[10px] uppercase tracking-[0.22em] text-neutral-500 leading-tight border-l border-black/10 pl-3">
                                The Rewarded
                                <br />
                                Growth Engine
                            </span>
                        </Link>
                        <p className="mt-5 text-sm text-neutral-500 max-w-xs leading-relaxed">
                            Mobile rewards, made simple. Earn. Save. Redeem.
                        </p>
                    </div>

                    <nav
                        aria-label="Footer"
                        className="md:justify-self-center"
                        data-testid="footer-nav"
                    >
                        <ul className="flex flex-col gap-3">
                            <li>
                                <Link
                                    to="/"
                                    data-testid="footer-link-home"
                                    className="text-sm text-neutral-700 hover:text-black link-underline"
                                >
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/how-it-works"
                                    data-testid="footer-link-how-it-works"
                                    className="text-sm text-neutral-700 hover:text-black link-underline"
                                >
                                    How It Works
                                </Link>
                            </li>
                            <li>
                                <a
                                    href="/#contact"
                                    data-testid="footer-link-contact"
                                    className="text-sm text-neutral-700 hover:text-black link-underline"
                                >
                                    Contact
                                </a>
                            </li>
                        </ul>
                    </nav>

                    <div className="md:justify-self-end">
                        <p className="text-xs uppercase tracking-[0.18em] text-neutral-400">
                            Contact
                        </p>
                        <a
                            href={MAILTO}
                            data-testid="footer-email-link"
                            className="mt-3 inline-block text-base md:text-lg text-black link-underline"
                        >
                            {CONTACT_EMAIL}
                        </a>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-black/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
                    <p
                        className="text-xs text-neutral-400"
                        data-testid="footer-copyright"
                    >
                        © {new Date().getFullYear()} FreeByte. All rights reserved.
                    </p>
                    <p className="text-xs text-neutral-400 tracking-wide">
                        The Rewarded Growth Engine
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
